import React, {PropTypes} from 'react';
import {I18N} from '../../../globals/config';
import classNames from 'classnames';
import JoinFooter from './join-footer';

const PartOne = (props) => (
	<div className="form-wrap">
		{!_.isEmpty( props.error_message ) && <div className="error">{props.error_message}</div>}
		<div className="first_name">
			<input
				className={classNames( {'error' : props.failed.indexOf( "first_name" ) != -1} )}
				type="text"
				name="first_name"
				value={props.first_name}
				onChange={props.onChange}
				placeholder={I18N.first_name}
			/>
			{props.failed.indexOf( "first_name" ) != -1 &&
			<span className="error">{I18N.first_name + ' ' + I18N.required}</span>}
		</div>
		<div className="last_name">
			<input
				className={classNames( {'error' : props.failed.indexOf( "last_name" ) != -1} )}
				type="text"
				name="last_name"
				value={props.last_name}
				onChange={props.onChange}
				placeholder={I18N.last_name}
			/>
			{props.failed.indexOf( "last_name" ) != -1 &&
			<span className="error">{I18N.last_name + ' ' + I18N.required}</span>}
		</div>

		<input
			className={classNames({ 'error' : props.failed.indexOf( "email" ) != -1})}
			type="text"
			name="email"
			value={props.email}
			onChange={props.onChange}
			placeholder={I18N.email}
		/>
		{props.failed.indexOf( "email" ) != -1 && <span className="error">{I18N.email + ' ' + I18N.required}</span>}
		<input
			className="button button-primary"
			type="submit"
			name="join-submit"
			value={I18N.join_now}
			onClick={props.changeStep}
			data-step="2"
		/>
		<JoinFooter changeStep={props.changeStep}/>
	</div>
);

PartOne.propTypes = {
	onChange : PropTypes.func.isRequired,
	changeStep : PropTypes.func.isRequired,
	first_name : PropTypes.string.isRequired,
	last_name : PropTypes.string.isRequired,
	failed    : PropTypes.array.isRequired,
	error_message : PropTypes.string.isRequired,
};

PartOne.DefaultProps = {
	first_name : "",
	last_name : "",
	failed    : [],
};


export default PartOne;


// WEBPACK FOOTER //
// ./src/components/modals/join/part-one.js